import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { MdContentCopy } from 'react-icons/md';

import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';
import { AppState } from 'services/types';
import RoleButton from 'components/RoleButton';
import SingleActiveTableRowGate from 'components/SingleActiveTableRowGate';
import ButtonIconWrapper from 'components/ButtonIconWrapper';
import { SprayEventUuid } from 'services/sprayEvents/types';
import { COPY_SPRAY_EVENT_MODAL } from '../../constants';
import { makeSelectCopySprayEventUuid } from './selectors';

interface ConnectedProps {
    sprayEventUuid?: SprayEventUuid;
}

type Props = ConnectedProps;

export class CopySprayEventButtonComponent extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { sprayEventUuid } = this.props;

        if (!sprayEventUuid) {
            return null;
        }

        return (
            <SingleActiveTableRowGate>
                <RoleButton
                    requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
                    params={{
                        [COPY_SPRAY_EVENT_MODAL]: true,
                        sprayEventUuid
                    }}
                    buttonProps={{
                        icon: true,
                        color: 'black',
                        basic: true,
                        style: {
                            margin: 0
                        }
                    }}
                >
                    <ButtonIconWrapper>
                        <MdContentCopy
                            style={{
                                fontSize: 20
                            }}
                        />
                    </ButtonIconWrapper>
                    Copy
                </RoleButton>
            </SingleActiveTableRowGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    sprayEventUuid: makeSelectCopySprayEventUuid()
});

export default connect(mapStateToProps)(CopySprayEventButtonComponent);
